import $ from '@vaersaagod/tools/Dom';
import BaseComponent from '../lib/BaseComponent';

export class Quiz extends BaseComponent {
    init() {
        this.restartButton = $(this.el).find('[data-restart]');
        this.questions = $(this.el).find('[data-question]');
        this.result = $(this.el).find('[data-result]');
        this.results = $(this.el).find('[data-results]');
        this.radioButtons = $(this.el).find('input');

        this.radioButtons.on('change', this.onRadioChange.bind(this));
        this.restartButton.on('click', this.onRestart.bind(this));
    }

    onRadioChange(e) {
        e.preventDefault();
        const checked = this.radioButtons.filter(':checked');
        if (checked.length === this.questions.length) {
            let total = 0;
            let done = false;
            checked.each(node => { total += parseInt(node.value, 10); });
            console.log('total', total);

            this.result.reverse().each(node => {
              if (!done && total >= parseInt(node.getAttribute('data-score'), 10)) {
                $(node).css('display', 'block');
                done = true;
              }
            });
            this.results.css('display', 'flex');
        }
    }

    onRestart(e) {
        e.preventDefault();
        this.radioButtons.each(node => { node.checked = false; });
        this.result.attr('style', null);
        this.results.css('display', 'none');
    }

    destroy() {
        this.radioButtons.off('change');
        this.restartButton.off('click');
    }
}

export default Quiz;



// WEBPACK FOOTER //
// ./src/js/components/Quiz.js